import {Button, Grid, Typography} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import Container from "../../../../../../common/Container";
import {useTranslation} from "react-i18next";
import {LotWithItemList} from "../../../../../../types/lot";
import {Company} from "../../../../../../types/company";
import {AuctionState, AuctionType} from "../../../../../../utils/enums";
import LotCard from "./components/LotCard";
import {AuctionLot} from "../../../../../../types/auction";

export type LotFieldsProps = {
    company: Company | null,
    lots: AuctionLot[],
    auctionType: AuctionType,
    auctionState: AuctionState,
}
export const LotFields = ({
                              company,
                              lots,
                              auctionType,
                              auctionState
                          }: LotFieldsProps) => {
    const {t} = useTranslation();

    const navigate = useNavigate();
    const [isNewOpen, setIsNewOpen] = React.useState(false);
    const onOpenLot = () => setIsNewOpen(true);

    return <Grid container>
            {!!lots && lots.length > 0 &&
                <Grid container spacing={3}>
                    {lots.map(lot => (
                        <Grid item xs={12} key={lot.id}>
                            <LotCard
                                id={lot.id}
                                lot={lot.lotDto}
                                maxItems={5}
                                company={company!}
                            />
                        </Grid>
                    ))}
                </Grid>
            }


    </Grid>
}